import React from "react";
import Frame302 from "../Frame302";
import "./Frame304.css";

function Frame304(props) {
  const { className, frame302Props } = props;

  return (
    <div className={`frame-304 ${className || ""}`}>
      <div className="frame-container">
        <img className="frame-301" src="/img/frame-301-1@2x.png" />
        <Frame302 className={frame302Props.className} />
      </div>
    </div>
  );
}

export default Frame304;
